export enum SnackbarMessage {
  // Accounting
  AccountLevelCreated = 'account_level_created',
  AccountLevelCreatedFailed = 'account_level_created_failed',
  AccountLevelUpdated = 'account_level_updated',
  AccountLevelUpdatedFailed = 'account_level_updated_failed',
  AccountLevelDeleted = 'account_level_deleted',
  AccountLevelDeletedFailed = 'account_level_deleted_failed',

  // API keys
  ApiKeyCreated = 'api_key_created',
  ApiKeyCreatedFailed = 'api_key_created_failed',
  ApiKeyDeleted = 'api_key_deleted',
  ApiKeyDeletedFailed = 'api_key_deleted_failed',
  ExportTablesAssignedToApiKey = 'export_tables_assigned_to_api_key',
  ExportTablesAssignedToApiKeyFailed = 'export_tables_assigned_to_api_key_failed',

  // MCP tokens

  // Chart of accounts
  ChartOfAccountsCreated = 'chart_of_accounts_created',
  ChartOfAccountsCreatedFailed = 'chart_of_accounts_created_failed',
  ChartOfAccountsUpdated = 'chart_of_accounts_updated',
  ChartOfAccountsUpdatedFailed = 'chart_of_accounts_updated_failed',
  ChartOfAccountsDeleted = 'chart_of_accounts_deleted',
  ChartOfAccountsDeletedFailed = 'chart_of_accounts_deleted_failed',

  // Company groups
  CompanyGroupCreated = 'company_group_created',
  CompanyGroupCreatedFailed = 'company_group_created_failed',
  CompanyGroupDeleted = 'company_group_deleted',
  CompanyGroupDeletedFailed = 'company_group_deleted_failed',
  CompanyGroupUpdated = 'company_group_updated',
  CompanyGroupUpdatedFailed = 'company_group_updated_failed',
  OntologyRerunStarted = 'ontology_rerun_started',
  OntologyRerunStartedFailed = 'ontology_rerun_started_failed',

  // Dashboards
  DashboardCreated = 'dashboard_created',
  DashboardCreatedFailed = 'dashboard_created_failed',
  DashboardDuplicated = 'dashboard_duplicated',
  DashboardDuplicatedFailed = 'dashboard_duplicated_failed',
  DashboardUpdated = 'dashboard_updated',
  DashboardUpdatedFailed = 'dashboard_updated_failed',
  DashboardDeleted = 'dashboard_deleted',
  DashboardDeletedFailed = 'dashboard_deleted_failed',
  DashboardRestored = 'dashboard_restored',
  DashboardRestoredFailed = 'dashboard_restored_failed',

  // Analysis types
  AnalysisTypeUpdated = 'analysis_type_updated',
  AnalysisTypeUpdatedFailed = 'analysis_type_updated_failed',

  // Analyses
  AnalysisDeleted = 'analysis_deleted',
  AnalysisDeletedFailed = 'analysis_deleted_failed',
  AnalysisRerun = 'analysis_rerun',
  AnalysisRerunFailed = 'analysis_rerun_failed',
  AnalysisRerunCancelled = 'analysis_rerun_cancelled',

  // Groups
  AccessRequested = 'access_requested',
  AccessRequestedFailed = 'access_requested_failed',
  GroupCreated = 'group_created',
  GroupCreatedFailed = 'group_created_failed',
  GroupDeleted = 'group_deleted',
  GroupDeletedFailed = 'group_deleted_failed',
  GroupUpdated = 'group_updated',
  GroupUpdatedFailed = 'group_updated_failed',
  YouJoinedGroup = 'you_joined_group',
  YouJoinedGroupFailed = 'you_joined_group_failed',
  YouLeftGroup = 'you_left_group',
  YouLeftGroupFailed = 'you_left_group_failed',

  // Entities
  ColumnsUpdated = 'columns_updated',
  ColumnsUpdatedFailed = 'columns_updated_failed',
  SliceCreated = 'slice_created',
  SliceCreatedFailed = 'slice_created_failed',
  SliceDeleted = 'slice_deleted',
  SliceDeletedFailed = 'slice_deleted_failed',
  SliceUpdated = 'slice_updated',
  SliceUpdatedFailed = 'slice_updated_failed',

  // Export Tables
  ExportTableCreated = 'export_table_created',
  ExportTableCreatedFailed = 'export_table_created_failed',
  ExportTableUpdated = 'export_table_updated',
  ExportTableUpdatedFailed = 'export_table_updated_failed',
  ExportTableDeleted = 'export_table_deleted',
  ExportTableDeletedFailed = 'export_table_deleted_failed',
  ExportTableApiKeysAssignedSuccess = 'export_table_api_keys_assigned_success',
  ExportTableApiKeysAssignedFailed = 'export_table_api_keys_assigned_failed',
  ExportTableColumnCreated = 'export_table_column_created',
  ExportTableColumnCreatedFailed = 'export_table_column_created_failed',
  ExportTableColumnUpdated = 'export_table_column_updated',
  ExportTableColumnUpdatedFailed = 'export_table_column_updated_failed',
  ExportTableColumnDeleted = 'export_table_column_deleted',
  ExportTableColumnDeletedFailed = 'export_table_column_deleted_failed',

  // Filters
  FilterCreated = 'filter_created',
  FilterCreatedFailed = 'filter_created_failed',
  FilterUpdated = 'filter_updated',
  FilterUpdatedFailed = 'filter_updated_failed',
  FilterDeleted = 'filter_deleted',
  FilterDeletedFailed = 'filter_deleted_failed',

  // Folders
  FolderCreated = 'folder_created',
  FolderCreatedFailed = 'folder_created_failed',
  FolderUpdated = 'folder_updated',
  FolderUpdatedFailed = 'folder_updated_failed',
  FolderDeleted = 'folder_deleted',
  FolderDeletedFailed = 'folder_deleted_failed',

  // Tags
  TagCreated = 'tag_created',
  TagCreatedFailed = 'tag_created_failed',

  // KPI:s
  KpiCreated = 'kpi_created',
  KpiCreatedFailed = 'kpi_created_failed',
  KpiDeleted = 'kpi_deleted',
  KpiDeletedFailed = 'kpi_deleted_failed',
  KpiUpdated = 'kpi_updated',
  KpiUpdatedFailed = 'kpi_updated_failed',
  KpiOrderUpdated = 'kpi_order_updated',
  KpiOrderUpdatedFailed = 'kpi_order_updated_failed',

  // Metrics
  MetricCreated = 'metric_created',
  MetricCreatedFailed = 'metric_created_failed',
  MetricUpdated = 'metric_updated',
  MetricUpdatedFailed = 'metric_updated_failed',
  MetricDeleted = 'metric_deleted',
  MetricDeletedFailed = 'metric_deleted_failed',
  MetricDefinitionRemoved = 'metric_definition_removed',
  MetricDefinitionRemovedFailed = 'metric_definition_removed_failed',

  // Reports
  ReportDuplicated = 'report_duplicated',
  ReportDuplicatedFailed = 'report_duplicated_failed',
  ReportPublished = 'report_published',
  ReportPublishedFailed = 'report_published_failed',
  ReportUnpublished = 'report_unpublished',
  ReportUnpublishedFailed = 'report_unpublished_failed',

  // Report Editions
  ReportEditionPublished = 'report_edition_published',
  ReportEditionPublishedFailed = 'report_edition_published_failed',
  ReportEditionUnpublished = 'report_edition_unpublished',
  ReportEditionUnpublishedFailed = 'report_edition_unpublished_failed',

  // Tabs
  TabCreated = 'tab_created',
  TabCreatedFailed = 'tab_created_failed',
  TabDuplicated = 'tab_duplicated',
  TabDuplicatedFailed = 'tab_duplicated_failed',
  TabDeleted = 'tab_deleleted',
  TabDeletedFailed = 'tab_deleleted_failed',
  TabMoved = 'tab_moved',
  TabMovedFailed = 'tab_moved_failed',

  // Tasks
  TaskCreated = 'task_created',
  TaskCreatedFailed = 'task_created_failed',
  TaskUpdated = 'task_updated',
  TaskUpdatedFailed = 'task_updated_failed',
  TaskDeleted = 'task_deleted',
  TaskDeletedFailed = 'task_deleted_failed',

  // Users
  UserCreated = 'user_created',
  UserCreatedFailed = 'user_created_failed',
  UserUpdated = 'user_updated',
  UserUpdatedFailed = 'user_updated_failed',
  UserDeleted = 'user_deleted',
  UserDeletedFailed = 'user_deleted_failed',

  // Widgets
  WidgetCreated = 'widget_created',
  WidgetCreatedFailed = 'widget_created_failed',
  WidgetUpdated = 'widget_updated',
  WidgetUpdatedFailed = 'widget_updated_failed',
  WidgetDeleted = 'widget_deleted',
  WidgetDeletedFailed = 'widget_deleted_failed',

  // Settings
  SettingsSaved = 'settings_saved',
  SettingsSavedFailed = 'settings_saved_failed',

  // Organizational Units
  OrganizationalUnitCreated = 'organizational_unit_created',
  OrganizationalUnitCreatedFailed = 'organizational_unit_created_failed',
  OrganizationalUnitUpdated = 'organizational_unit_updated',
  OrganizationalUnitUpdatedFailed = 'organizational_unit_updated_failed',
  OrganizationalUnitDeleted = 'organizational_unit_deleted',
  OrganizationalUnitDeletedFailed = 'organizational_unit_deleted_failed',

  // AI chat
  ChatFeedbackSent = 'chat_feedback_sent',
  ChatFeedbackSentFailed = 'chat_feedback_sent_failed',

  // General
  CopiedToClipboard = 'copied_to_clipboard',
  CopiedToClipboardFailed = 'copied_to_clipboard_failed',
  FileUploaded = 'file_uploaded',
  FileUploadedFailed = 'file_uploaded_failed',
  FileExported = 'file_exported',
  FileExportedFailed = 'file_exported_failed',
  FileDownloadFailed = 'file_download_failed',
  RequestSent = 'request_sent',
  RequestSentFailed = 'request_sent_failed',

  // Generic internal UI only
  Success = 'success',
  Failed = 'failed'
}

export enum SnackbarLinkText {
  NavigateToDashboard = 'navigate_to_dashboard'
}

export interface SnackbarLink {
  link: () => void
  text: SnackbarLinkText
}

export interface SnackbarOptions {
  link?: SnackbarLink
  duration?: number
}
